<template>
  <div class="w-table-action-wrapper">
    <slot v-if="readonly === null || readonly !== true" />
  </div>
</template>

<script>
/**
 * @component WorkTableActionWrapper
 * @description Wrapper for table row actions. Shows the content only when
 * `readonly` is not set to `true`.
 *
 * @prop {Boolean|null} [readonly=null] - When `true`, actions are hidden.
 *
 * @slot default - Action buttons (e.g. edit, delete).
 */
export default {
  name: 'WorkTableActionWrapper',
  props: {
    readonly: { type: Boolean, default: null }
  },
};
</script>

<style lang='scss'>
.w-table-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
